// simple initializer for video list swiper instances
(function () {
  if (typeof window === 'undefined') return;
  if (window.__videoListSliderBooted) return;
  window.__videoListSliderBooted = true;

  const RETRY_DELAY = 150;
  const MAX_RETRIES = 40;

  function initSlider(sliderEl, retryCount = 0) {
    if (!sliderEl) return;
    const wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const Swiper = window.Swiper || window.swiper || null;
    if (!Swiper) {
      if (retryCount >= MAX_RETRIES) return;
      setTimeout(() => initSlider(sliderEl, retryCount + 1), RETRY_DELAY);
      return;
    }

    const ds = sliderEl.dataset;
    let autoplay = ds.autoplay === 'true';
    const loop = ds.loop === 'true';
    const delay = parseInt(ds.delay, 10) || 4000;
    const spaceBetween = parseInt(ds.gap || '30', 10);
    const colsMobile = parseInt(ds.colsMobile || '1', 10);
    const colsTablet = parseInt(ds.colsTablet || colsMobile, 10);
    const colsDesktop = parseInt(ds.colsDesktop || colsTablet, 10);
    const totalSlides = wrapper.querySelectorAll('.swiper-slide').length;
    const maxSlidesPerView = Math.max(colsMobile, colsTablet, colsDesktop);
    const shouldLoop = loop && totalSlides > maxSlidesPerView;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      autoplay = false;
    }

    // destroy previously stored instance
    if (sliderEl.swiperInstance && sliderEl.swiperInstance.destroy) {
      sliderEl.swiperInstance.destroy(true, true);
    }

    const progressEl = sliderEl.querySelector('.video-list__progress');
    const paginationConfig = progressEl
      ? { el: progressEl, type: 'progressbar' }
      : false;

    sliderEl.swiperInstance = new Swiper(sliderEl, {
      loop: shouldLoop,
      autoplay: autoplay ? { delay, disableOnInteraction: false } : false,
      spaceBetween,
      pagination: paginationConfig,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      slidesPerView: colsMobile,
      breakpoints: {
        768: { slidesPerView: colsTablet },
        1024: { slidesPerView: colsDesktop }
      }
    });

    // swipers often add inline `height` styles to slides. clear them so
    // the CSS aspect-ratio rule (and our !important overrides) can work.
    const resetSlideHeights = () => {
      sliderEl.querySelectorAll('.swiper-slide').forEach((s) => {
        // remove any height property so the browser respects aspect-ratio
        s.style.height = '';
      });
      // also make sure wrapper isn't locked to a height
      const wrapperEl = sliderEl.querySelector('.swiper-wrapper');
      if (wrapperEl) wrapperEl.style.height = '';
    };

    // call immediately and also on various Swiper events that could touch
    // heights (resize, slide change, etc.)
    resetSlideHeights();
    if (sliderEl.swiperInstance && sliderEl.swiperInstance.on) {
      sliderEl.swiperInstance.on('resize', resetSlideHeights);
      sliderEl.swiperInstance.on('observerUpdate', resetSlideHeights);
      sliderEl.swiperInstance.on('slideChange', resetSlideHeights);
    }
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll('.video-list').forEach((slider) => initSlider(slider));
  }

  // run on DOM ready and also allow later initialization if needed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  window.addEventListener('load', () => initAll(document));

  document.addEventListener('shopify:section:load', (event) => {
    const section = event && event.target ? event.target : document;
    initAll(section);
  });

  document.addEventListener('shopify:section:reorder', () => initAll(document));
  document.addEventListener('shopify:block:select', () => initAll(document));
})();
